module.exports = __webpack_public_path__ + "static/img/xxtb3.707dff14.png";